import Home from './components/Home/Home';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import TiendaOnline from './components/TiendaOnline/TiendaOnline';
import Contactanos from './components/Contactanos/Contactanos';

function App() {
  return (

    <div className="App">
      <Routes>


        <Route path='/' element={<Home />} />
        <Route path='/quienes-somos' element={<Home />} />
        <Route path='/tienda-online' element={<TiendaOnline />} />
        <Route path='/contactanos' element={<Contactanos />} />

      </Routes>




    </div>
  );
}

export default App;
